import React, { useState, useEffect } from 'react';
import { Form, Col, Row, Input, Select, Divider, Switch, Progress, Button, Icon } from 'antd';
import InputCurrency, { currency2Float } from '~/components/UI/InputCurrency';
import SelectWithAdd from '~/components/UI/SelectWithAdd';
import { InstallmentsTable } from '../Tables/InstallmentsTable';
import { PERMISSIONS } from '~/constants/permissions.constants';

import AssignTo from '~/components/AssignTo';
import Stages from '../components/Stages';

const { Option, OptGroup } = Select;

const FormChange = (props) => {
  const [defaultState, setDefaultState] = useState({
    id: null,
    customer_id: null,
    description: null,
    amount: 0.00,
    create_payments: false,
    paid_off: false,
    stages: {},
    assigned_to: null,
  });

  const { getFieldDecorator, getFieldValue, setFieldsValue } = props.form;
  const { customers, user, data, category } = props;

  const isRequired = category === 2 ? true : false;

  useEffect(() => {
    setDefaultState((prevState) => ({ ...prevState, ...data }));
  }, [data]);

  const getInitialCustomer = (data) => {
    if (!data.deleted_customer) {
      return data.customer_id;
    }
    return `${data.deleted_customer.cod} - ${data.deleted_customer.name}`;
  };

  return (
    <Form>
      <Row gutter={16} className="mb-30">
        {(category === 2 && (defaultState.customer_id === null || defaultState.id === null)) && (
          <Col span={24}>
            <Form.Item label="Empresa">
              {getFieldDecorator('customer_id', defaultState.customer_id ? {
                initialValue: getInitialCustomer(data),
                rules: [{ required: isRequired, message: 'Por favor selecione uma opção!' }],
              } : {
                rules: [{ required: isRequired, message: 'Por favor selecione uma opção!' }],
              })(
                <SelectWithAdd
                  placeholder="Selecione uma empresa"
                  disabled={!!defaultState.id}
                  onChange={val => setDefaultState({ ...defaultState, customer_id: val })}
                  setForm={(val) => setFieldsValue({ customer_id: val })}
                >
                  <OptGroup label="Clientes">
                    {customers.filter(row => row.is_customer).map(row =>
                      <Option value={row.id} key={row.id}>{row.cod ? `${row.cod} - ${row.name}` : row.name}</Option>
                    )}
                  </OptGroup>
                  <OptGroup label="Não Clientes">
                    {customers.filter(row => !row.is_customer).map(row =>
                      <Option value={row.id} key={row.id}>{row.cod ? `${row.cod} - ${row.name}` : row.name}</Option>
                    )}
                  </OptGroup>
                </SelectWithAdd>
              )}
            </Form.Item>
          </Col>
        )}
        <Col span={24}>
          <Form.Item label="Solicitação da diretoria">
            {getFieldDecorator('description', {
              initialValue: defaultState.description,
              rules: [{ required: isRequired, message: 'Campo obrigatório' }],
            })(
              <Input.TextArea rows={4} placeholder="Descreva em detalhes" disabled={(defaultState.id != null && data.created_by !== user.id) && data.description !== null} />
            )}
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item>
            {getFieldDecorator('stages', {
              initialValue: defaultState.stages,
            })(
              <Stages initial={defaultState.stages} category={category} taskId={defaultState.id} notes={defaultState.stage_notes} stageList={defaultState.stage_list} />
            )}
          </Form.Item>
        </Col>
        <Col span={12}>
            <AssignTo form={props.form} initialValue={defaultState.assigned_to} />
        </Col>
        {(category === 1 || category === 5) && (
        <Col span={24}>
          {(function() {
            var isNf = getFieldValue('allow_nf') !== undefined ? getFieldValue('allow_nf') : (defaultState.allow_nf || false);
            return (
              <div style={{
                marginBottom: 16, padding: '16px 20px', borderRadius: 10,
                border: '1.5px solid ' + (isNf ? '#bae7ff' : '#e8e8e8'),
                background: isNf ? '#f0f9ff' : '#fff',
                display: 'flex', alignItems: 'center', gap: 16, transition: 'all 0.2s',
              }}>
                <div style={{
                  width: 40, height: 40, borderRadius: 8,
                  background: isNf ? '#1890ff18' : '#f5f5f5',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0
                }}>
                  <Icon type="file-text" style={{ fontSize: 20, color: isNf ? '#1890ff' : '#8c8c8c' }} />
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 600, fontSize: 14, color: '#262626', marginBottom: 2 }}>Serviço de emissão de NF</div>
                  <div style={{ fontSize: 13, color: '#8c8c8c' }}>O cliente optou por contratar/pagar o serviço de emissão de notas fiscais.</div>
                  {defaultState.allow_nf_changed_at && (
                    <div style={{ fontSize: 12, color: '#bfbfbf', marginTop: 4 }}>
                      {defaultState.allow_nf ? 'Habilitado' : 'Desabilitado'} por {defaultState.allow_nf_changed_by_name || 'usuário'} em {new Date(defaultState.allow_nf_changed_at).toLocaleDateString('pt-BR')}
                    </div>
                  )}
                </div>
                {getFieldDecorator('allow_nf', { valuePropName: 'checked', initialValue: defaultState.allow_nf || false })(
                  <Switch checkedChildren="Sim" unCheckedChildren="Não" />
                )}
              </div>
            );
          })()}
        </Col>
        )}
        <Col span={24}>
          <Form.Item label="Resposta do executor">
            {getFieldDecorator('answer', {
              initialValue: defaultState.answer,
            })(
              <Input.TextArea rows={4} placeholder="Descreva detalhes adicionais" />
            )}
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default FormChange;